import type { CurrencyCode } from '@/lib/money'

export interface AccountOption {
  readonly currency: CurrencyCode
  readonly label: string
  readonly rail: string
  readonly note: string
}

/**
 * The accounts Pass issues, as designed on screen 10: four currencies with
 * local details. Colombia and Bolivia are corridors you send money to, not
 * accounts you hold — there is no peso or boliviano account.
 */
export const ACCOUNT_OPTIONS: readonly AccountOption[] = [
  {
    currency: 'USD',
    label: 'US Dollar',
    rail: 'Routing & account number · ACH',
    note: 'Where salary and transfers land',
  },
  { currency: 'EUR', label: 'Euro', rail: 'IBAN & BIC · SEPA Instant', note: 'For work in Europe' },
  { currency: 'MXN', label: 'Mexican Peso', rail: 'CLABE · SPEI', note: 'Arrives in minutes' },
  {
    currency: 'BRL',
    label: 'Brazilian Real',
    rail: 'PIX key & agency · TED',
    note: 'Arrives in minutes',
  },
]

export interface CardOption {
  readonly id: 'virtual' | 'physical' | 'agent' | 'both'
  readonly title: string
  readonly price: string
  readonly body: string
  readonly icon: string
}

/**
 * Card prices are paid on activation, never when the card is created: the
 * virtual card when you switch it on, the plastic when it is in your hands.
 */
export const CARD_OPTIONS: readonly CardOption[] = [
  {
    id: 'virtual',
    title: 'Virtual card',
    price: '$9 at activation',
    body: 'Live the moment you activate it, for online payments. Wallets need the physical card.',
    icon: 'smartphone',
  },
  {
    id: 'physical',
    title: 'Physical card',
    price: '$50 at activation',
    body: 'Arrives in about a week and is paid when you activate it. ATMs, contactless, and all three phone wallets.',
    icon: 'credit_card',
  },
  {
    id: 'agent',
    title: 'Agent card',
    price: 'Free',
    body: 'For an AI agent to spend on your behalf, inside limits you set.',
    icon: 'smart_toy',
  },
  {
    id: 'both',
    title: 'Both',
    price: '$9 + $50 at activation',
    body: 'Activate the virtual one to spend today, and the plastic when it arrives, for cash and travel.',
    icon: 'layers',
  },
]
